class Validator {
  constructor(onError) {
    this.onError = onError;
    this.errors = new Set();
  }
}

export default Validator;